import { Home, PlayView } from "../pages";

const routes = [
  { path: "/", component: Home }, // Home page is the default page
  { path: "/tournament/:tournament_id", component: PlayView }, // Home page is the default page
];

export default routes;
